import React from 'react';

const opusMimeType = 'audio/webm;codecs=opus';

function getMediaRecorderOptions() {
  return { audioBitsPerSecond: 32000, mimeType: opusMimeType };
}

function hasLiveAudioTrack(stream: MediaStream) {
  return stream.getAudioTracks().some((track) => track.readyState === 'live');
}

export default function useAudioRecorder(
  stream: MediaStream | null,
  ondataavailable: (data: ArrayBuffer) => void,
  onError?: (error: unknown) => void,
) {
  const streamRef = React.useRef<MediaStream | null>(null);
  const ondataavailableRef = React.useRef(ondataavailable);
  const onErrorRef = React.useRef(onError);
  React.useEffect(
    () => { streamRef.current = stream; },
    [stream],
  );
  React.useEffect(
    () => { ondataavailableRef.current = ondataavailable; },
    [ondataavailable],
  );
  React.useEffect(
    () => { onErrorRef.current = onError; },
    [onError],
  );

  React.useEffect(
    () => {
      let recorder: MediaRecorder | null = null;
      if (stream?.id && streamRef.current && typeof MediaRecorder !== 'undefined' && hasLiveAudioTrack(streamRef.current)) {
        try {
          recorder = new MediaRecorder(streamRef.current, getMediaRecorderOptions());
        } catch (error) {
          console.error('Failed to create audio recorder', error);
          onErrorRef.current?.(error);
          return undefined;
        }

        recorder.ondataavailable = async (e) => {
          const chunk = e.data;
          const arrayBuffer = await chunk.arrayBuffer();
          if (recorder?.state === 'recording') {
            ondataavailableRef.current(arrayBuffer);
          }
        };
        try {
          recorder.start(400);
        } catch (error) {
          console.error('Failed to start audio recorder', error);
          onErrorRef.current?.(error);
          recorder = null;
          return undefined;
        }
      }
      return () => {
        if (recorder && recorder.state !== 'inactive') {
          recorder.stop();
        }
      };
    },
    [stream?.id],
  );
}
